import { render, staticRenderFns } from "./rewardCard.vue?vue&type=template&id=69fa64ea&scoped=true&"
import script from "./rewardCard.vue?vue&type=script&lang=js&"
export * from "./rewardCard.vue?vue&type=script&lang=js&"
import style0 from "./rewardCard.vue?vue&type=style&index=0&id=69fa64ea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fa64ea",
  null
  
)

export default component.exports